import { FeatureFlags } from '@/modules/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsCardClaimSuspensionAvailable = (): boolean =>
  useFeatureFlag(FeatureFlags.CARD_CLAIM_SUSPENSION);